import { FunctionComponent, useEffect } from 'react'
import styled from 'styled-components'
import config from '@config'
import { CommentingConfirmationMessageProps } from './types'

const {
  community: { messageDisplayTimeout },
} = config

const ConfirmationMessage = styled.div`
  box-sizing: border-box;
  padding: 1.25rem;
  background-color: ${({ theme }) => theme.colors.grey.grey_75};
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.sourceSansPro};
  font-size: 18px;
  line-height: 1.22;
`

const CommentingConfirmationMessage: FunctionComponent<
  CommentingConfirmationMessageProps
> = ({ onTimeout, children }) => {
  useEffect(() => {
    const timeout = setTimeout(onTimeout, messageDisplayTimeout)
    return () => clearTimeout(timeout)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <ConfirmationMessage>{children}</ConfirmationMessage>
}

export default CommentingConfirmationMessage
